import moment from 'moment';
import { BADGE_DOWNLOAD_TYPE } from '../types/enums';
import { v4 } from 'uuid';
import { BadgeDownloadLog } from '../utils/types';
import { XAppName, XAppNameHeader } from '../types/badge';

const logBadgeDownloadedEvent = (url: string, type: BADGE_DOWNLOAD_TYPE, badgeToken: string, xAppName?: XAppNameHeader) =>
  fetch(`${url}/v1/events/badgedownloads/batch`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CorrelationId': v4(),
      ...(xAppName ?? {})
    },
    body:
      JSON.stringify({
        addBadgeDownloadEvents: [{ source: type, badgeToken, eventDate: moment().utc().format() }]
      })
  })
    .then((response) => response.json())
    .catch((err) => err);

const logBadgeDownloadedEventSync = (url: string, type: BADGE_DOWNLOAD_TYPE, badgeToken: string, xAppName: XAppName): Promise<BadgeDownloadLog> =>
  fetch(`${url}/v1/events/badgedownloads`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CorrelationId': v4(),
      'X-App-Name': xAppName
    },
    body: JSON.stringify({ source: type, badgeToken, eventDate: moment().utc().format() })
  })
    .then((response) => response.json())
    .catch((err) => err);

const RingboxService = {
  logBadgeDownloadedEvent,
  logBadgeDownloadedEventSync
};

export default RingboxService;
